jQuery( document ).ready(function($) {

  $('.video-item .trigger').click(function(){
    const id = $(this).attr('data-video-id')
    $(this).append(`<iframe allow="accelerometer; autoplay; encrypted-media; gyroscope;picture-in-picture" allowfullscreen frameborder="0" src="https://www.youtube.com/embed/${id}"></iframe>`);
  })

});